import { closeModal, openModal } from './modal.js'

// Only select biography-related modal triggers
const modalTriggers = document.querySelectorAll('[data-modal-target$="-biography"]')

modalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function(event) {
        event.preventDefault();
        openModal(trigger.dataset.modalTarget, trigger)
        return false;
    })
})
